import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type GoalsStrategyController from 'webapp/controllers/goals/strategy';

export default class GoalsStrategyRoute extends Route {
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;

	override async beforeModel() {
		if (this.mmGoalsService.isGoalsOKRsEnabled) {
			await this.mmGoalsService.requestCompanyStrategy();
		}
	}

	override afterModel() {
		document.body.id = 'page-goals-okrs';
	}

	override setupController(controller: GoalsStrategyController) {
		controller.loadViewSettings();
	}
}
